export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-heading font-black text-primary-400">91</span>
              <span className="text-sm font-semibold text-background-100 whitespace-nowrap">
                免费视频网站
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              91免费视频网站致力于打造优质国产免费视频在线观看平台，汇集91国产免费视频、91传媒视频在线等海量高清资源，每日更新，无需缓冲，为您带来流畅的观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '投稿咨询', href: '#contact' },
                { label: '观众热评', href: '#comments' },
                { label: '专题索引', href: '#index' },
                { label: '热度榜单', href: '#ranking' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {['国产剧情', '传媒精选', '高清合集', '每日更新', '热门推荐'].map((cat) => (
                <span key={cat} className="text-sm text-background-400 whitespace-nowrap">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              感谢各大内容合作伙伴的长期支持，共同为观众提供优质的国产免费视频观看体验。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 91免费视频网站. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              联系我们
            </a>
            <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              常见问题
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}